import { render, staticRenderFns } from "./MovieItem.vue?vue&type=template&id=09e75d20&"
import script from "./MovieItem.vue?vue&type=script&lang=js&"
export * from "./MovieItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports